import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import React from 'react';
import cx from 'classnames';
import Icon from '@clearscore/rainbow.icons.cross';
import PortalCore from '@clearscore/ui.rainbow.portal-core';
var styles = {
  "themeLight": "themeLight--o3YAi",
  "themeDark": "themeDark--gpj8G",
  "placementRight": "placementRight--LUrfP",
  "isOpenTransition": "isOpenTransition--u6Wcy",
  "placementLeft": "placementLeft--2bPGc",
  "placementBottom": "placementBottom--yTDzO",
  "drawerContent": "drawerContent--zCe4f",
  "close": "close--zgVKb",
  "backdrop": "backdrop--KgKlr"
};

/* eslint-disable react/require-default-props */
var Placement = {
  RIGHT: 'RIGHT',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT'
};
var Theme = {
  LIGHT: 'LIGHT',
  DARK: 'DARK'
};
var DrawerContext = /*#__PURE__*/React.createContext({});
var useDrawerContext = function useDrawerContext() {
  var drawerContext = React.useContext(DrawerContext);
  if (!drawerContext) {
    throw new Error('Drawer compound components must be rendered within the Drawer component');
  }
  return drawerContext;
};
var Backdrop = function Backdrop(_ref) {
  var onClick = _ref.onClick;
  var _PortalCore$useContex = PortalCore.useContext(),
    isOpenTransition = _PortalCore$useContex.isOpenTransition;
  return /*#__PURE__*/React.createElement(PortalCore.Backdrop, null, /*#__PURE__*/React.createElement("div", {
    "data-qa": "drawer-backdrop",
    className: cx(styles.backdrop, _defineProperty({}, styles.isOpenTransition, isOpenTransition)),
    onClick: onClick
  }));
};
var CloseIcon = function CloseIcon(_ref2) {
  var onClick = _ref2.onClick,
    label = _ref2.label;
  return /*#__PURE__*/React.createElement(PortalCore.Toggle, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    type: "button",
    onClick: onClick,
    "data-qa": "drawer-close-button"
  }, /*#__PURE__*/React.createElement(Icon, {
    height: 24,
    width: 24,
    title: label
  })));
};
// set/override the theme per content
var Content = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var _cx2;
  var ariaLabel = _ref3.ariaLabel,
    ariaLabelledBy = _ref3.ariaLabelledBy,
    ariaDescribedBy = _ref3.ariaDescribedBy,
    children = _ref3.children,
    themeOverride = _ref3.theme,
    placementOverride = _ref3.placement,
    _ref3$closeLabel = _ref3.closeLabel,
    _closeLabel = _ref3$closeLabel === void 0 ? '' : _ref3$closeLabel;
  var _PortalCore$useContex2 = PortalCore.useContext(),
    isOpenTransition = _PortalCore$useContex2.isOpenTransition;
  var context = useDrawerContext();
  var theme = themeOverride || context.theme;
  var placement = placementOverride || context.placement;
  return /*#__PURE__*/React.createElement(PortalCore.Content, {
    ariaLabel: ariaLabel,
    ariaLabelledBy: ariaLabelledBy,
    ariaDescribedBy: ariaDescribedBy
  }, /*#__PURE__*/React.createElement("div", {
    "data-id": context.dataId,
    "data-qa": "drawer-content",
    className: cx(styles.drawerContent, (_cx2 = {}, _defineProperty(_cx2, styles.isOpenTransition, isOpenTransition), _defineProperty(_cx2, styles.themeLight, theme === Theme.LIGHT), _defineProperty(_cx2, styles.themeDark, theme === Theme.DARK), _defineProperty(_cx2, styles.placementRight, placement === Placement.RIGHT), _defineProperty(_cx2, styles.placementBottom, placement === Placement.BOTTOM), _defineProperty(_cx2, styles.placementLeft, placement === Placement.LEFT), _cx2)),
    ref: ref
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    label: _closeLabel
  }), children));
});
var Drawer = function Drawer(_ref4) {
  var children = _ref4.children,
    _ref4$dataId = _ref4.dataId,
    _dataId = _ref4$dataId === void 0 ? '' : _ref4$dataId,
    _ref4$placement = _ref4.placement,
    _placement = _ref4$placement === void 0 ? Placement.RIGHT : _ref4$placement,
    _ref4$isOpenOverride = _ref4.isOpenOverride,
    _isOpenOverride = _ref4$isOpenOverride === void 0 ? false : _ref4$isOpenOverride,
    _ref4$onClose = _ref4.onClose,
    _onClose = _ref4$onClose === void 0 ? undefined : _ref4$onClose,
    _ref4$onOpen = _ref4.onOpen,
    _onOpen = _ref4$onOpen === void 0 ? undefined : _ref4$onOpen,
    _ref4$theme = _ref4.theme,
    _theme = _ref4$theme === void 0 ? Theme.LIGHT : _ref4$theme;
  var value = React.useMemo(function () {
    return {
      theme: _theme,
      placement: _placement,
      dataId: _dataId
    };
  }, [_dataId, _placement, _theme]);
  return /*#__PURE__*/React.createElement(DrawerContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(PortalCore, {
    isOpenOverride: _isOpenOverride,
    transitionOutDuration: 250,
    onClose: _onClose,
    onOpen: _onOpen
  }, /*#__PURE__*/React.createElement(Backdrop, null), children));
};
Drawer.Placement = Placement;
Drawer.Theme = Theme;
Drawer.Content = Content;
Drawer.Toggle = PortalCore.Toggle;
Drawer.useContext = PortalCore.useContext;
export default Drawer;